<template>
    <div class="navsholder">
        <div v-for="(nav, navidx) in navs" :key="navidx" class="navitem nousersel">
            <div @click="set_view(nav[1])" v-bind:class="nav[1] == $store.state.current_view ? 'selectedview' : ''">{{
                    nav[0]
            }}</div>
        </div>
    </div>
</template>

<script>
import ENUMS from './Enums'

export default {
    name: "NavsComp"
    , methods: {
        set_view(teh_view) {
            this.$store.commit("changeView", teh_view)
        }
    }
    , data() {
        var ends = [
            ['Main', ENUMS.VIEWS.MAIN]
            , ['Mint', ENUMS.VIEWS.MINT]
            , ['My NFTs', ENUMS.VIEWS.MYNFTS]
            , ['Coals on Sale', ENUMS.VIEWS.LISTONSALE]
            , ['List NFTs', ENUMS.VIEWS.LISTNFTS]
            , ['Coal Mine', ENUMS.VIEWS.MINE]
            , ['Heists', ENUMS.VIEWS.HEISTS]
            , ['Track', ENUMS.VIEWS.TRACK]
            // , ['SACRIFICE', ENUMS.VIEWS.SACRIFICE]
            , ['Settings', ENUMS.VIEWS.SETTINGS]
            , ['Help', ENUMS.VIEWS.HELP]]
        if (
            process.env.NODE_ENV === 'development') {
            ends.push(['Debug', ENUMS.VIEWS.DEBUG])
        }
        return {
            ENUMS: ENUMS
            , navs: ends
        }
    }
}
</script>

<style scoped>
.navsholder {
    flex-grow: 5;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
}

.navitem {
    text-decoration: underline;

    cursor: pointer;
    margin-right: 3%;
    margin-top: 10px;
    transition: 0.2s;


}

.navitem:hover {
    text-decoration: none;
    transform: scale(1.1);

}

.selectedview {
    color: rgb(163, 47, 47);
    text-decoration: underline;
    text-decoration-color: rgb(163, 47, 47);


}
</style>